import { Component, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Content } from 'ionic-angular';
import { NavController, NavParams, Slides, LoadingController, Platform } from 'ionic-angular';
import { ApiService } from '../../app/services/api.service';
import { Broadcaster } from '../../app/broadcaster';
import { Localization } from '../../app/app.localization';
import { Storage } from '@ionic/storage';
import { AlertController } from 'ionic-angular';
import { Config } from '../../app/app.config';
import { ModalController } from 'ionic-angular';
import { OrderModalPage } from "../order-modal/order-modal";
import { CustomModalComponent } from '../../components/custom-modal/custom-modal';
import { OkageGoGoogleAnalyticsProvider } from '../../providers/okage-go-google-analytics/okage-go-google-analytics';
import { OkageStorageProvider } from '../../providers/okage-storage/okage-storage'

@Component({
    selector: 'page-menulayouts',
    templateUrl: 'Menulayouts.html',
    providers: [ApiService]
})

export class MenulayoutsPage {

    @ViewChild('indexMenu') indexMenu: ElementRef;
    @ViewChild('layouts') layouts: any;
    @ViewChild('returnToTop') returnToTop: any;
    @ViewChild('foodDetailSequence') foodDetailSequence: any;
    @ViewChild('Content') content: any;

    tabs: any = '0';

    items: Array<Array<{ id: number, title: string, desc: string, thumb: string, price: number, like: number; aIndex: number, iIndex: number, content: any }>>;
    indexes: Array<{ page: number, title: string }>;
    iFoods: Array<Array<number>>;
    iTotal: number;
    loading: any;
    readycount: number;

    menus: Array<Array<{ id: number, title: string, desc: string, thumb: string, price: number, notax_price: number, like: number; liked: boolean, sub: any, is_rock: any, is_soldout_rock: any, is_wait_arrival_rock: any, menu_classification_id: any, allergy: any, menu_limit_in_order: any}>>;
    iCounter: Array<Array<number>>;
    iCounterTotal: Array<Array<number>>;
    currentItem: { id: number, title: string, desc: string, thumb: string, price: number, aIndex: number, iIndex: number, like: number, liked: boolean, subParts: any, flowQtt: any, flowQttItem: any, isSelect: Array<boolean>, allergy: Array<boolean>, flowSelectedSequence:any, menu_limit_in_order: any };
    subMenu: any;
    subMenuTotal: any;
    foodDetailState: string;
    foodDetailSubsState: string;
    iconClicked: boolean;
    configs: any = JSON.parse(localStorage.getItem('configs'));
    soflow: any;
    soIndex: number = 0;
    needReadyCount: number = 3;
    indexMenuShown = false;
    subMst = JSON.parse(this._okageStorage.getItem('menuGroup.mst'));
    subSortMap = [];
    urls: any;
    lockedContent = [];
    lockedMenuIds = [];
    client_cd;
    store_id;
    topLayout;
    showReturnToTop = false;
    quantityOption = [];
    quantitySubOption = [];
    currentPrice: number;
    quantity: number = 1;
    nextButtonActive: boolean = false;
    requiredSelectCount = 0;
    historyOrder: any;
    chargeId: any;
    orderList = [];
    orderListNum: number = 0;

    ionViewDidEnter() {
        console.log("view did enter");
        console.log(this.layouts);
        console.log(this.layouts._scrollContent.nativeElement);
        if (localStorage.getItem("clickReturnToTop") == "true") {
            this.orderListNum = 0;
            this.orderList = [];
            localStorage.removeItem('clickReturnToTop');
            this.clickReturnToTop();
        }
        this.layouts._scrollContent.nativeElement.addEventListener("scroll", () => {
            if (!this.topLayout) {
                this.topLayout = document.querySelector('#layout0');
            } else {
                let shows = (this.topLayout.clientHeight < this.layouts._scrollContent.nativeElement.scrollTop);
                if (this.showReturnToTop != shows) {
                    if (shows) {
                        this.rd.removeClass(this.returnToTop.nativeElement, "return_to_top_hide");
                        this.rd.addClass(this.returnToTop.nativeElement, "return_to_top_show");
                    } else {
                        this.rd.addClass(this.returnToTop.nativeElement, "return_to_top_hide");
                        this.rd.removeClass(this.returnToTop.nativeElement, "return_to_top_show");
                    }
                }
                this.showReturnToTop = shows;
            }
        });
    }

    scrollListener() {
        console.log(this);
    }

    /**
     *
     * @param navCtrl
     * @param navParams
     * @param _productService
     */
    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        private _loc: Localization,
        private _apiService: ApiService,
        private storage: Storage,
        private broadcaster: Broadcaster,
        private alertCtrl: AlertController,
        private loadingCtrl: LoadingController,
        public platform: Platform,
        private rd: Renderer2,
        private _ga: OkageGoGoogleAnalyticsProvider,
        private _okageStorage: OkageStorageProvider,
        public modalCtrl: ModalController
    ) {

        this.client_cd = localStorage.getItem("client_cd");
        this.store_id = localStorage.getItem("store_id");
        this.readycount = 0;
        this.foodDetailState = '';
        this.foodDetailSubsState = '';
        this.iconClicked = false;
        this.currentItem = {
            id: 0,
            title: '',
            desc: '',
            thumb: '',
            price: 0,
            aIndex: -1,
            iIndex: -1,
            like: 0,
            liked: false,
            subParts: null,
            flowQtt: null,
            flowQttItem: null,
            flowSelectedSequence: [],
            isSelect: [],
            allergy: [],
            menu_limit_in_order: 0
        };

        this.iFoods = [];
        this.items = [];
        this.indexes = [];
        this.menus = [];
        this.iCounter = [];
        this.loading = this.loadingCtrl.create();
        this.soflow = true;
        this.iTotal = 0;

        // 詳細画面の数量の選択肢を作成
        for (let i = 1; i < 100; i++) {
            this.quantityOption.push({
                count: i
            });
        }

        for (let i = 0; i < 100; i++) {
            this.quantitySubOption.push({
                count: i
            });
        }
        localStorage.setItem("orderList", JSON.stringify(""));
        //this.loading.present();

        this.storage.get('menulayouts').then((v) => {
            this.storage.get("urls").then((u) => {
                if (v && v.length > 0) {
                    this.urls = u;
                    this.items = v;
                    for (var idx in this.items) {
                        if (this.items[idx]["index_name"].length > 0) {
                            this.indexes.push({
                                page: this.items[idx]["page"],
                                title: this.items[idx]["index_name"]
                            });
                        }
                    }
                    this.storage.get('foods.menu').then((v) => {
                        this.menus = v;
                        var locked = [];
                        for (let k in this.menus) {
                            for (let i in this.menus[k]) {
                                let m = this.menus[k][i];
                                if (parseInt(m.is_rock, 0) > 0 ||
                                    parseInt(m.is_soldout_rock, 0) > 0 ||
                                    parseInt(m.is_wait_arrival_rock, 0) > 0) {
                                    locked[parseInt(m.id + "", 0)] = m;
                                }
                            }
                        }

                        let contents = [];
                        for (var idx in this.items) {
                            contents[idx] = [];
                            var viewsize = 1.0;
                            if (document.getElementsByClassName("orderbookpage_image")[idx]) {
                                viewsize = document.getElementsByClassName("orderbookpage_image")[idx]["width"];
                            }
                            else {
                                continue;
                            }
                            if (this.items[idx]["content"].length > 0) {
                                let c = JSON.parse(this.items[idx]["content"]);
                                if (c) {
                                    for (var i in c) {
                                        if (c[i].menu_id != undefined && locked[parseInt(c[i].menu_id + "", 0)] != undefined) {
                                            let per = viewsize / parseInt(this.items[idx]["image_width"] + "", 0);
                                            if (c[i]["nowrap"] == undefined || parseInt(c[i]["nowrap"] + "", 0) < 1) {
                                                let rock = "";
                                                if (locked[parseInt(c[i].menu_id + "", 0)].is_soldout_rock == 1){
                                                    rock = "is_soldout_rock";
                                                }else if (locked[parseInt(c[i].menu_id + "", 0)].is_rock == 1) {
                                                    rock = "is_rock";
                                                }else if (locked[parseInt(c[i].menu_id + "", 0)].is_wait_arrival_rock == 1) {
                                                    rock = "is_wait_arrival_rock";
                                                }
                                                contents[idx].push({
                                                    menu: locked[parseInt(c[i].menu_id + "", 0)],
                                                    layoutContent: c[i],
                                                    x: (c[i].x * per) + 8,
                                                    y: (c[i].y * per) + 13,
                                                    w: c[i].width * per,
                                                    h: c[i].height * per,
                                                    src: Config.service + "?r=menus/soldoutimage&client_cd=" + this.client_cd + "&store_id=" + this.store_id +"&"+rock,
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        this.lockedContent = contents;
                        this.lockedMenuIds = locked;

                        this.subMst = JSON.parse(this._okageStorage.getItem('menuGroup.mst'));
                        this.foodCounterChanged();
                    });
                } else {
                    // Error
                }
            });
        })
            .catch((error) => {
                console.log("menulayouts storage error");
                console.log(error);
            });


        this.broadcaster.on<number>('submenuChanged')
            .subscribe(from => {
                if (from != 8) {
                    let tmp = JSON.parse(this._okageStorage.getItem('foods.submenu'));
                    for (var key in this.subMenuTotal) {
                        for (var j = 0; j < this.subMenuTotal[key].length; j++) {
                            this.subMenuTotal[key][j].quantity = tmp[key][j].quantity;
                        }
                    }
                }
            });

        this.broadcaster.on<number>('foodCounterChanged')
            .subscribe(from => {
                if (from != 1) {
                    this.foodCounterChanged();
                }
            });

        this.broadcaster.on<number>('foodLikeChanged')
            .subscribe(from => {
                if (from != 1) {
                    this.foodLikeChanged();
                }
            });

        this.chargeId = localStorage.getItem("chargeId");
    }

    heightPop(){
        // var hp = String(this.platform.height() - 48) + 'px';
        var hp = String(window.innerHeight - 48) + 'px';
        return hp;
    }

    ionViewWillEnter() {
        this._ga.menulayoutsPageView();
        var orderHistory = JSON.parse(localStorage.getItem("orderHistory"));
        if (orderHistory !== null ) {
            this.storage.get('foods.menu').then((v) => {
                console.log(v);
                this.menus = v;
                var menuId = Number(orderHistory.id);
                this.detailPopup((menuId), this.soflow);
            })
            localStorage.removeItem('orderHistory');
        }
    }
    ionViewDidLeave() {
        this.closeIndexMenu();
    }

    openIndexMenu() {
        this.indexMenuShown = true;
        this.rd.removeClass(this.indexMenu.nativeElement, "index_menu_hide");
        this.rd.addClass(this.indexMenu.nativeElement, "index_menu_show");
    }
    closeIndexMenu() {
        this.indexMenuShown = false;
        this.rd.removeClass(this.indexMenu.nativeElement, "index_menu_show");
        this.rd.addClass(this.indexMenu.nativeElement, "index_menu_hide");
    }
    selectIndex(idx) {
        this.closeIndexMenu();
        this.scrollToPage(parseInt(idx.page, 0) - 1);

    }

    priceString(price) {
        var newPrice;
        newPrice = String(price).split('.');
        newPrice[0] = newPrice[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        return newPrice.join('.');
    }

    mergeAllergyText(currentItem) {
        var allergyText = "";
        currentItem.allergy.forEach(allergy => {
            allergyText += allergy.allergy_name+" / ";
        });
        allergyText = allergyText.slice(0, -2)
        return allergyText;
    }

    tapIndex(index) {
        console.log(index);
    }

    tapPage(item, obj) {
        if (!item.content) return;
        if (obj.target.className != "orderbookpage_image") return;
        let contents = JSON.parse(item.content);
        let touchX = obj.offsetX;
        let touchY = obj.offsetY;
        let touched_menu_id = -1;
        let touched_content = false;
        for (let idx in contents) {
            let per = parseInt(item.image_width, 0) / parseInt(obj.target.width, 0);
            let originalWidth = item.image_width;
            if (contents[idx].objectType == "rect") {
                if (this.isRectHit(contents[idx], touchX * per, touchY * per)) {
                    touched_content = contents[idx];
                    touched_menu_id = parseInt(contents[idx].menu_id, 0);
                    break;
                }
            }
            else if (contents[idx].objectType == "circle") {
                if (this.isCircleHit(contents[idx], touchX * per, touchY * per)) {
                    touched_content = contents[idx];
                    touched_menu_id = parseInt(contents[idx].menu_id, 0);
                    break;
                }
            }
        }

        if (touched_content["menu_id"] != undefined && parseInt(touched_content["menu_id"], 0) > 0) {
            let touchedMenuId = parseInt(touched_content["menu_id"], 0);
            if (this.lockedMenuIds[touchedMenuId] == undefined) {
                this.detailPopup(parseInt(touched_content["menu_id"], 0), this.soflow);
            }
        }
        else if (touched_content["url"] != undefined && touched_content["url"].length > 0) {
            let url = touched_content["url"];
            let url_id = parseInt(touched_content["url_id"], 0);
            let ignorePopup = this.configs['MOBILEORDER_IGNORE_POPUP_ACCESS_EXTERNAL_SITE'];
            if (this.urls) {
                for (let i = 0; i < this.urls.length; i++) {
                    if (parseInt(this.urls[i]["url_id"], 0) === url_id) {
                        url = this.urls[i]["url"];
                        break;
                    }
                }
            }
            if (ignorePopup === undefined || ignorePopup !== '1') {
                if (window.confirm(touched_content["url_name"] + " (" + url + ")" + this._loc.t('を開きます。よろしいですか？'))) {
                    window.open(url, "_blank");
                }
            } else {
                window.open(url, "_blank");
            }
        }
        else if (this.indexes.length > 0 && touched_content["index_title"] != undefined && touched_content["index_title"].length > 0) {
            for (var i = 0; i < this.indexes.length; i++) {
                if (this.indexes[i]["title"] == touched_content["index_title"]) {
                    this.scrollToPage(parseInt(this.indexes[i].page + "", 0) - 1);
                    break;
                }
            }
        }
    }

    detailPopup(menu_id: any, fromSubs = false) {
        document.getElementById('food-detail-container').scrollTop = 0;
        document.getElementById('food-detail-subs-container').scrollTop = 0;

        let aIndex = -1;
        let iIndex = -1;

        for (let a = 0; a < this.menus.length; a++) {
            for (let b = 0; b < this.menus[a].length; b++) {
                if (this.menus[a][b].id == menu_id) {
                    aIndex = a;
                    iIndex = b;
                    break;
                }
            }
            if (aIndex >= 0 && iIndex >= 0) {
                break;
            }
        }

        if (aIndex !== -1 && iIndex !== -1) {
            if (this.menus[aIndex][iIndex].sub && this.menus[aIndex][iIndex].sub.length > 0) {
                for (let i = 0; i < this.menus[aIndex][iIndex].sub.length; i++) {
                    let obj = this.menus[aIndex][iIndex].sub[i];
                    let parent_menu_id = obj.parent;
                    let mg_menu_id = obj.group_id;
                    let mg_sub_menu_id = obj.id;
                    this.menus[aIndex][iIndex].sub[i].sort_order_in_group = parseInt(this.searchFromSubMst(mg_menu_id, mg_sub_menu_id), 0);
                    this.menus[aIndex][iIndex].sub[i].sort_order = parseInt(this.searchFromSubMst(parent_menu_id, mg_menu_id), 0);
                    //this.menus[aIndex][iIndex].sub[i].selected = 0;
                }
                this.menus[aIndex][iIndex].sub.sort((a, b) => {
                    if (a.sort_order > b.sort_order) return 1;
                    if (a.sort_order < b.sort_order) return -1;
                    if (a.sort_order_in_group > b.sort_order_in_group) return 1;
                    if (a.sort_order_in_group < b.sort_order_in_group) return -1;
                });
                let recentGroupId = "";
                for (let t = 0; t < this.menus[aIndex][iIndex].sub.length; t++) {
                    if (this.menus[aIndex][iIndex].sub[t].group_id != recentGroupId) {
                        this.menus[aIndex][iIndex].sub[t].first = true;
                    } else {
                        this.menus[aIndex][iIndex].sub[t].first = false;
                    }
                    recentGroupId = this.menus[aIndex][iIndex].sub[t].group_id;
                }
            }

            this.currentItem = {
                id: this.menus[aIndex][iIndex].id,
                title: this.menus[aIndex][iIndex].title,
                desc: this.menus[aIndex][iIndex].desc,
                thumb: this.menus[aIndex][iIndex].thumb,
                price: this.menus[aIndex][iIndex].price,
                aIndex: aIndex,
                iIndex: iIndex,
                like: this.menus[aIndex][iIndex].like,
                liked: this.menus[aIndex][iIndex].liked,
                subParts: null,
                flowQtt: null,
                flowQttItem: null,
                flowSelectedSequence: [],
                isSelect: [],
                allergy: this.menus[aIndex][iIndex].allergy,
                menu_limit_in_order: (this.menus[aIndex][iIndex].menu_limit_in_order > 0) ? this.menus[aIndex][iIndex].menu_limit_in_order : 99
            };
            if (fromSubs){
                this._ga.menulayoutsDetailPopup(this.currentItem.title);
            }
        }
        this.updateCurrentPrice();
        if (fromSubs) {
            this.foodDetailSubsState = (this.menus[aIndex][iIndex].menu_classification_id == '6') ? 'food-detail-up-sequence' : 'food-detail-up';
        } else {
            this.foodDetailState = 'food-detail-up';
        }

        this.iconClicked = true;
        if (!this.subMenu) {
            this.subMenu = JSON.parse(this._okageStorage.getItem('foods.submenu'));
            // clear quantity for new order
            for (let i in this.subMenu) {
                for (let j = 0; j < this.subMenu[i].length; j++) {
                    this.subMenu[i][j].quantity = 0;
                }
            }
        }
        for (var i = 0; i < this.menus.length; i++) {
            for (var j = 0; j < this.menus[i].length; j++) {
                if (typeof this.subMenu[this.menus[i][j].id] !== 'undefined') {
                    this.menus[i][j].sub = this.subMenu[this.menus[i][j].id];
                }
            }
        }

        this.currentItem.subParts = [];
        if (!fromSubs) {
            this.hideDetailPopup();
        } else {
            this.soIndex = 0;
            this.currentItem.subParts = [];
            this.currentItem.flowQtt = [];
            this.currentItem.flowQttItem = [];
            if (aIndex !== -1 && iIndex !== -1) {
                // menu has no sub
                if (typeof this.menus[aIndex][iIndex].sub == 'undefined' || this.menus[aIndex][iIndex].sub.length < 1) {
                    this.clickFinishFlow(menu_id);
                    return;
                }
                this.nextButtonActive = false;
                let csubs = this.menus[aIndex][iIndex].sub.length;
                let cpIndex = 0;
                this.currentItem.subParts[cpIndex] = [];
                this.currentItem.flowQtt[menu_id] = [];
                this.currentItem.flowQttItem[menu_id] = [];
                for (var i = 0; i < csubs; i++) {
                    this.currentItem.flowQtt[menu_id][i] = 0;
                    this.currentItem.flowQttItem[menu_id][i] = this.menus[aIndex][iIndex].sub[i];
                    this.menus[aIndex][iIndex].sub[i].index = i;
                    if ('group_name' in this.menus[aIndex][iIndex].sub[i]) {
                        if (i > 0) {
                            if ('group_name' in this.menus[aIndex][iIndex].sub[i - 1]) {
                                if (this.menus[aIndex][iIndex].sub[i].group_name != this.menus[aIndex][iIndex].sub[i - 1].group_name) {
                                    this.currentItem.subParts[++cpIndex] = [];
                                }
                            } else {
                                this.currentItem.subParts[++cpIndex] = [];
                            }
                        }
                        this.currentItem.subParts[cpIndex].push(this.menus[aIndex][iIndex].sub[i]);
                    } else {
                        if (i > 0) {
                            this.currentItem.subParts[++cpIndex] = [];
                            this.currentItem.subParts[cpIndex].push(this.menus[aIndex][iIndex].sub[i]);
                        } else {
                            this.currentItem.subParts[cpIndex].push(this.menus[aIndex][iIndex].sub[i]);
                        }
                    }
                }
            }
            if (this.currentItem.subParts && this.currentItem.subParts.length > 0) {
                var optionsRowCount = 0;
                for (let i = 0; i < this.currentItem.subParts.length; i++) {
                    for (let t = 0; t < this.currentItem.subParts[i].length; t++) {
                        let obj = this.currentItem.subParts[i][t];
                        this.currentItem.subParts[i][t].sort_order_in_group = this.searchFromSubMst(obj.group_id, obj.id);
                        let rock = "";
                        if (this.currentItem.subParts[i][t].is_soldout_rock == 1) rock = "is_soldout_rock";
                        if (this.currentItem.subParts[i][t].is_wait_arrival_rock == 1) rock = "is_wait_arrival_rock";
                        if (this.currentItem.subParts[i][t].is_rock == 1) rock = "is_rock";
                        if (rock != "") {
                            this.currentItem.subParts[i][t].soldout_src = Config.service + "?r=menus/soldoutimage&client_cd=" + this.client_cd + "&store_id=" + this.store_id + "&"+rock;
                        }
                    }
                    // 展開メニューでサブメニューが必須項目ではない場合、次へボタンは活性化させる
                    if (this.currentItem.subParts[i][0].required) {
                        optionsRowCount++;
                    }
                    this.currentItem.subParts[i].sort((a, b) => {
                        if (parseInt(a.sort_order, 0) > parseInt(b.sort_order, 0)) return 1;
                        if (parseInt(a.sort_order, 0) < parseInt(b.sort_order, 0)) return -1;
                        if (parseInt(a.sort_order_in_group, 0) > parseInt(b.sort_order_in_group, 0)) return 1;
                        if (parseInt(a.sort_order_in_group, 0) < parseInt(b.sort_order_in_group, 0)) return -1;
                    });
                    
                    this.currentItem.subParts.selectCount = 0;
                    if (i == 0) {
                        this.currentItem.subParts[i].selected = false;
                        this.currentItem.subParts[i].visible = true;
                        this.currentItem.subParts[i].visibleSubMenu = true;
                        this.currentItem.subParts[i].selectMenuName = "";
                        this.currentItem.subParts[i].thumb = "";
                    } else {
                        this.currentItem.subParts[i].selected = false;
                        this.currentItem.subParts[i].visible = false;
                        this.currentItem.subParts[i].visibleSubMenu = false;
                        this.currentItem.subParts[i].selectMenuName = "";
                        this.currentItem.subParts[i].thumb = "";
                    }
                }
                // if (optionsRowCount == 0) {
                //     this.nextButtonActive = true;
                // }
                this.updateNextButtonActive();
            }
        }
        this.setMenuLimitQuantity();
    }

    searchFromSubMst(menu_id, sub_menu_id) {
        if (this.subSortMap.length < 1) {
            this.subSortMap = [];
            if (this.subMst && this.subMst.length > 0) {
                for (let i = 0; i < this.subMst.length; i++) {
                    this.subSortMap[this.subMst[i].menu_id + "_" + this.subMst[i].sub_menu_id] = this.subMst[i].sort_order;
                }
            }
        }
        if (this.subSortMap[menu_id + "_" + sub_menu_id]) {
            return this.subSortMap[menu_id + "_" + sub_menu_id];
        }
        return -1;
    }

    isCircleHit(item, x, y) {
        let rad = item.degree * Math.PI / 180.0;
        let cx = item.x + item.width / 2;
        let cy = item.y + item.height / 2;
        let rx = item.width / 2;
        let ry = item.height / 2;

        let Ofs_x = x - cx;
        let Ofs_y = y - cy;
        var After_x = Ofs_x * Math.cos(rad) + Ofs_y * Math.sin(rad);
        var After_y = rx / ry * (-Ofs_x * Math.sin(rad) + Ofs_y * Math.cos(rad));
        return (After_x * After_x + After_y * After_y <= rx * rx);

    }

    isRectHit(item, x, y) {
        let minx = item.x;
        let maxx = item.x + item.width;
        let miny = item.y;
        let maxy = item.y + item.height;
        let rad = (360 - item.degree) / 180 * Math.PI;
        let cx = item.x + item.width / 2;
        let cy = item.y + item.height / 2;

        let x1 = x - cx;
        let y1 = y - cy;
        let px = x1 * Math.cos(rad) - y1 * Math.sin(rad) + cx;
        let py = x1 * Math.sin(rad) - y1 * Math.cos(rad) + cy;
        return (px > minx && px < maxx && py > miny && py < maxy);
    }


    foodCounterChanged() {
        this.iCounterTotal = [];
        this.iTotal = 0;
        this.storage.get('foods.selected').then((v) => {
            if (v) {
                if (!this.subMenuTotal) {
                    if (!this.subMenu){
                        this.subMenu = JSON.parse(this._okageStorage.getItem('foods.submenu'));
                    }
                    this.subMenuTotal = JSON.parse(JSON.stringify(this.subMenu));
                }
                this.iCounterTotal = v;
                for (var i = 0; i < this.menus.length; i++) {
                    for (var j = 0; j < this.menus[i].length; j++) {
                        if (typeof this.subMenuTotal[this.menus[i][j].id] !== 'undefined') {
                            this.menus[i][j].sub = this.subMenuTotal[this.menus[i][j].id];
                        }
                    }
                }
            }
            this.countTotal();
        });
        this.orderList = JSON.parse(localStorage.getItem('orderList')) ? JSON.parse(localStorage.getItem('orderList')) : [];
        this.countTotal();
    }


    hideDetailPopup(fromSubs = false, clearData = false) {
        this.quantity = 1;
        if (fromSubs) {
            this.iconClicked = false;
            this.foodDetailSubsState = '';
            if (clearData) {
                this.iCounter = [];
                this.requiredSelectCount = 0;
                // clear quantity for new order
                for (let i in this.subMenu) {
                    for (let j = 0; j < this.subMenu[i].length; j++) {
                        this.subMenu[i][j].quantity = 0;
                    }
                }
            }
            return;
        }
        if (!this.iconClicked) {
            if (clearData) {
                this.foodDetailState = '';
                this.iCounter = [];
                // clear quantity for new order
                for (let i in this.subMenu) {
                    for (let j = 0; j < this.subMenu[i].length; j++) {
                        this.subMenu[i][j].quantity = 0;
                    }
                }
            } else {
                let r = this.validateTenkaiMenu();
                if (r) {
                    this.foodDetailState = '';
                }
            }
        } else {
            this.iconClicked = false;
        }
    }

    chooseFood(aIndex, iIndex) {
        if (this.iconClicked) {
            return;
        }
        if (!this.iCounter[aIndex]) {
            this.iCounter[aIndex] = [];
        }
        if (!this.iCounter[aIndex][iIndex]) {
            this.iCounter[aIndex][iIndex] = 0;
        }
        this.iCounter[aIndex][iIndex]++;
    }

    removeFood(aIndex, iIndex, desFromImage) {
        if (desFromImage) {
            this.iconClicked = true;
        }
        if (!this.iCounter[aIndex]) {
            return;
        }
        if (!this.iCounter[aIndex][iIndex]) {
            return;
        }
        this.iCounter[aIndex][iIndex]--;
    }

    changeQuantity() {
    }

    changeSubParts(subIndex) {
        this.currentItem.subParts.selectCount = 0;
        this.currentItem.subParts.forEach(sub => {
            sub.visibleSubMenu = false; // 全てのサブメニューグループを非表示にする
            if (sub.selected) {
                this.currentItem.subParts.selectCount++;
            } else {
                sub.visible = false; // サブメニューグループが未選択のものを非表示にする
            }
        });
        // 変更ボタンを押したサブメニューグループを表示、未選択にする
        this.currentItem.subParts[subIndex].selected = false;
        this.currentItem.subParts[subIndex].selectMenuName = "";
        this.currentItem.subParts[subIndex].thumb = "";
        this.currentItem.subParts[subIndex].visible = true;
        this.currentItem.subParts[subIndex].visibleSubMenu = true;
        let index = this.currentItem.subParts[subIndex].findIndex(sub => sub.quantity == "1"); // 表示中のサブメニューグループを検索
        if (index != -1) {
            this.currentItem.subParts[subIndex][index].quantity--;
            this.currentItem.flowQtt[this.currentItem.subParts[subIndex][index].parent][this.currentItem.subParts[subIndex][index].index]--;
        }
        this.nextButtonActive = false;
        this.scrollSubPartsSequence();
    }
    foodDetailBottom(Container = false) {
        // サブメニューグループがシーケンスの場合のみbottomを調整する
        if (this.foodDetailSubsState == 'food-detail-up-sequence') {
            var index = this.currentItem.subParts.findIndex(sub => sub.visibleSubMenu == true); // 展開して表示されているサブメニューグループを検索
            var visibleSubMenuCount = 0;
            this.currentItem.subParts.forEach((sub,i) => {
                if (sub.visible && i > index) {
                    visibleSubMenuCount++; // 展開して表示されているサブメニューグループをより後のサブメニューグループが選択済みのものを探す
                }
            });
            if (Container && visibleSubMenuCount > 0) return '115px'; // 条件に当てはまるものがあり、コンテナーの場合は115pxを返す
            if (!Container && visibleSubMenuCount == 0) return '115px'; // 選択済みのサブメニューグループがなく、サブメニューグループは115pxを返す
        }
        return '0px'; // それ以外の場合は0pxを返す
    }

    updateCurrentPrice(subPrice: number = 0) {
        var price: number = (this.currentItem.price * this.quantity);
        if (this.currentItem.flowQtt) {
            var i: number = this.currentItem.flowQtt[this.currentItem["id"]].length;
            for (var j = 0; j < i; j++) {
                price += this.currentItem.flowQtt[this.currentItem["id"]][j] * this.currentItem.flowQttItem[this.currentItem["id"]][j].price * this.quantity;
            }
        }
        this.currentPrice = price;

    }
    private countTotal() {
        var total: number = 0;
        for (let i = 0; i < this.orderList.length; i++) {
          if (this.orderList[i].menu_id !== this.chargeId) {
            total += Number(this.orderList[i].quantity);
          }
        }
        this.iTotal = total;
        this.storage.set('iTotal', this.iTotal);
    }

    ionViewDidLoad() {
        // this.pageSlider.freeMode = true;
    }
    selectTab(index) {
    }
    like(item) {
        let aIndex = item.aIndex;
        let iIndex = item.iIndex;
        if (!this.menus[aIndex][iIndex].liked) {
            item.liked = true;
            item.like++;
            this.menus[aIndex][iIndex].liked = true;
            this.menus[aIndex][iIndex].like++;
            this.storage.get('foods.menu').then((ms) => {
                if (ms) {
                    for (var i = 0; i < ms.length; i++) {
                        for (var j = 0; j < ms[i].length; j++) {
                            if (ms[i][j].id == item.id) {
                                ms[i][j].liked = item.liked;
                                ms[i][j].like = item.like;
                                break;
                            }
                        }
                    }

                    this.storage.set('foods.menu', ms).then((a) => {
                        this.broadcaster.broadcast('foodLikeChanged', 1);
                        this._apiService.like(item.id).subscribe(
                            (result) => {
                                console.log(result);
                            });
                    });
                }
            });
        } else {
            item.liked = false;
            item.like--;
            this.menus[aIndex][iIndex].liked = false;
            this.menus[aIndex][iIndex].like--;
            this.storage.get('foods.menu').then((ms) => {
                if (ms) {
                    for (var i = 0; i < ms.length; i++) {
                        for (var j = 0; j < ms[i].length; j++) {
                            if (ms[i][j].id == item.id) {
                                ms[i][j].liked = item.liked;
                                ms[i][j].like = item.like;
                                break;
                            }
                        }
                    }

                    this.storage.set('foods.menu', ms).then((a) => {
                        this.broadcaster.broadcast('foodLikeChanged', 1);
                        this._apiService.unlike(item.id).subscribe(
                            (result) => {
                                console.log(result);
                            });
                    });
                }
            });
        }
    }

    foodLikeChanged() {
        console.log('go like changed recommend');
        this.storage.get('foods.menu').then((m) => {
            if (m) {
                this.menus = m;
                if (this.currentItem && this.currentItem.aIndex >= 0 && this.currentItem.iIndex >= 0) {
                    this.currentItem.like = this.menus[this.currentItem.aIndex][this.currentItem.iIndex].like;
                    this.currentItem.liked = this.menus[this.currentItem.aIndex][this.currentItem.iIndex].liked;
                }
            }
        });
    }

    clickReturnToTop() {
        this.scrollToPage(0);
    }

    /**
     * 使ってなさそうだから全消し。一応保持
     */
    // clicksubDescrease(menuid, subindex) {
    //     if (!this.subMenu[menuid][subindex]) {
    //         return;
    //     }
    //     if (this.subMenu[menuid][subindex].quantity <= 0) {
    //         return;
    //     }
    //     this.subMenu[menuid][subindex].quantity--;
    // }
    clicksubDecrease(menuid, subindex, selectedId){
        let targetSubmenu = null;
        for (var i = 0; i < this.currentItem.subParts.length; i++) {
            if (this.currentItem.subParts[i][0].group_id == subindex) {
                var subs = this.currentItem.subParts[i];
                for (let s of subs) {
                    if (s.index == selectedId) {
                        targetSubmenu = s;
                        break;
                    }
                }
            }
        }
        if (targetSubmenu && this.currentItem.flowSelectedSequence[targetSubmenu.group_id]) {
            let seq = this.currentItem.flowSelectedSequence[targetSubmenu.group_id];
            var index = -1;
            for (let r = seq.length - 1; r >= 0; r--) {
                if (seq[r].id == targetSubmenu.id) {
                    index = r;
                    break;
                }
            }
            if (index >= 0) {
                var nseq = seq.slice(0, index).concat(seq.slice(index + 1, seq.length));
                this.currentItem.flowSelectedSequence[targetSubmenu.group_id] = nseq;
            }
        }
        this.currentItem.flowQtt[menuid][selectedId]--;
        this.updateNextButtonActive();

        var i: number = this.currentItem.flowQtt[menuid].length;
        var subPrice: number = 0;
        for (var j = 0; j < i; j++) {
            subPrice += this.currentItem.flowQtt[menuid][j] * this.currentItem.flowQttItem[menuid][j].price;
        }
        this.updateCurrentPrice(subPrice);

    }

    clicksubIncrease(menuid, subindex, selectedId, fromSub = false) {
        var optionsRowCount = 0;
        var isSelect = false;
        if (fromSub) {
            // subsは選ばれたサブが属するグループのすべてのメニューが入る
            let subs = [];
            let targetSubmenu = null;
            for (var i = 0; i < this.currentItem.subParts.length; i++) {
                if (this.currentItem.subParts[i][0].group_id == subindex) {
                    subs = this.currentItem.subParts[i];
                    for (let s of subs) {
                        if (s.index == selectedId) {
                            targetSubmenu = s;
                            break;
                        }
                    }
                }
                if (this.currentItem.subParts[i][0].required) {
                    optionsRowCount++;
                }
            }

            var subtotal = 0;   // subの数量合計を保持
            for (var i = 0; i < subs.length; i++) {
                if (this.currentItem.flowQtt[menuid][subs[i].index] == 1) {
                    isSelect = true;
                }
                subtotal += this.currentItem.flowQtt[menuid][subs[i].index];
            }
            // reset quantity number of required group menu
            if (subs[0].required) {
                for (var i = 0; i < subs.length; i++) {
                    this.currentItem.flowQtt[menuid][subs[i].index] = 0;
                }
                this.currentItem.flowQtt[menuid][selectedId] = 1;
                if (!isSelect) {
                    this.requiredSelectCount++;
                }
                // add sequence
                if (targetSubmenu) {
                    this.currentItem.flowSelectedSequence[targetSubmenu.group_id] = [];
                    this.currentItem.flowSelectedSequence[targetSubmenu.group_id].push(targetSubmenu);
                }
            }
            else if(subs[0].parent_min > 0 || subs[0].parent_max > 0){
                // min と maxがある場合
                if (subs[0].parent_max > subtotal){
                    // maxがsubtotal以上だったらincrement
                    this.currentItem.flowQtt[menuid][selectedId]++;
                    // add sequence
                    if (targetSubmenu) {
                        if (!this.currentItem.flowSelectedSequence[targetSubmenu.group_id]) {
                            this.currentItem.flowSelectedSequence[targetSubmenu.group_id] = [];
                        }
                        this.currentItem.flowSelectedSequence[targetSubmenu.group_id].push(targetSubmenu);
                    }
                }
            }
            else {
                this.currentItem.flowQtt[menuid][selectedId] = parseInt(this.currentItem.flowQtt[menuid][selectedId]);
            }
        } else {
            this.subMenu[menuid][subindex].quantity++;
        }

        // 必須のサブメニューを選択すると、次へボタンが活性化する
        // if (this.requiredSelectCount >= optionsRowCount) {
        //     this.nextButtonActive = true;
        // }
        // nextButtonActiveはincreaseのみで変わるわけではないので、validateは別にしたい
        this.updateNextButtonActive();

        var i: number = this.currentItem.flowQtt[menuid].length;
        var subPrice: number = 0;
        for (var j = 0; j < i; j++) {
            subPrice += this.currentItem.flowQtt[menuid][j] * this.currentItem.flowQttItem[menuid][j].price;
        }
        this.updateCurrentPrice(subPrice);
    }
    clickFoodDetailSequenceSub(menuid, subindex, selectedId, order) {
        this.currentItem.subParts.selectCount++;
        let index = this.currentItem.subParts.findIndex(sub => sub.visibleSubMenu == true); // 表示中のサブメニューグループを検索
        this.currentItem.subParts[index].selected = true; // 表示中のサブメニューグループを選択済みに変更
        this.currentItem.subParts[index][order-1].quantity++; // 選択したサブメニューの数量を足す
        this.currentItem.subParts[index].selectMenuName = this.currentItem.subParts[index][order-1].title; // 選択したサブメニュー名を設定
        this.currentItem.subParts[index].thumb = this.currentItem.subParts[index][order-1].thumb; // 選択したサブメニューの画像を設定
        this.currentItem.subParts[index].visibleSubMenu = false; // サブメニューグループを非表示に変更

        index = this.currentItem.subParts.findIndex(sub => sub.selected == false); // 未選択のサブメニューグループを検索

        if (index == -1) {
            this.nextButtonActive = true; // 全てのサブメニューグループが選択済みの場合、決定ボタンを活性
        } else {
            this.nextButtonActive = false; // 未選択のサブメニューグループがある場合、次のサブメニューグループを表示、決定ボタンを非活性、
            this.currentItem.subParts[index].visible = true;
            this.currentItem.subParts[index].visibleSubMenu = true;
        }

        this.currentItem.flowQtt[menuid][selectedId]++;
        var i: number = this.currentItem.flowQtt[menuid].length;
        var subPrice: number = 0;
        for (var j = 0; j < i; j++) {
            subPrice += this.currentItem.flowQtt[menuid][j] * this.currentItem.flowQttItem[menuid][j].price;
        }
        this.updateCurrentPrice(subPrice);
        this.scrollSubPartsSequence();
    }
    scrollSubPartsSequence() {
        var scrollSubParts = this.currentItem.subParts.findIndex(sub => sub.visibleSubMenu == true);
        if (scrollSubParts == -1) {
            document.getElementById('food-detail-container').scrollTo(0,400);
            document.getElementById('food-detail-subs-container').scrollTo(0,400);
        } else {
            document.getElementById('food-detail-container').scrollTo(0,275+53*scrollSubParts);
            document.getElementById('food-detail-subs-container').scrollTo(0,275+53*scrollSubParts);
        }
    }

    /**
     * nextButtonActiveの状態をアップデート
     *
     * 単品の際はこれがtrueじゃなくても決定はactiveだから、
     * subの場合のみ気にすればよい
     *
     */
    updateNextButtonActive(){
        // 一つでもだめならfalseなので、とりあえずtrueにして、falseあったらかえて即返し
        this.nextButtonActive = true;

        // もしsubなかったらtrue
        if (!this.currentItem.subParts || this.currentItem.subParts.length < 1){
            return;
        }

        /**
         * sub groupを一つずつチェックしてvalidate
         */
        for (let subs of this.currentItem.subParts){
            /**
             * ちなみにsubs[0]とかやってるのは、subのひとつひとつに、親のrequiredをいれてるから
             * いれてるのはapp.components.ts:469あたり
             */
            let parent_menu_id = this.currentItem.id;
            let flowQtt = this.currentItem.flowQtt[parent_menu_id];
            var subtotal = 0; // subの合計個数
            for (let subitem of subs){
                subtotal += flowQtt[subitem.index];
            }
            if (subs[0].required){
                // 必須のグループ - 全部0ならfalse
                console.log("CHECK FOR REQUIRED GROUP");
                if (subtotal < 1){
                    console.warn("   - [FAIL] NOT SELECTED");
                    this.nextButtonActive = false;
                    return;
                }
                console.log("   - PATH");
            }
            else if(subs[0].parent_min > 0){
                // minが設定されている場合
                console.log("CHECK FOR OPTION MIN");
                if (subtotal < subs[0].parent_min){
                    console.warn("  - [FAIL] NOT ENOUGHT MIN:"+subs[0].parent_min+" CURRENT:"+subtotal);
                    this.nextButtonActive = false;
                    return;
                }
                console.log("   - PATH MIN:"+subs[0].parent_min+" CURRENT:"+subtotal);
            }
            else if (subs[0].parent_max > 0){
                console.log("CHECK FOR OPTION MAX");
                if (subtotal > subs[0].parent_max){
                    console.warn("  - [FAIL] OVER MAX:"+subs[0].parent_max+" CURRENT:"+subtotal);
                    this.nextButtonActive = false;
                    return;
                }
                console.log("   - PATH");
            }
            if (this.foodDetailSubsState == 'food-detail-up-sequence' && subs.visibleSubMenu) {
                console.log("Not all sequences processed");
                this.nextButtonActive = false;
                return;
            }
        }
        console.log("PASS ALL");
    }

    clickPrevFlow() {
        if (this.soIndex > 0) {
            this.nextButtonActive = true;
            this.soIndex--;
        }
    }

    clickFinishFlow(menuid) {
        // update main menu quantity
        if (!this.iCounter[this.currentItem.aIndex]) {
            this.iCounter[this.currentItem.aIndex] = [];
        }
        if (!this.iCounter[this.currentItem.aIndex][this.currentItem.iIndex]) {
            this.iCounter[this.currentItem.aIndex][this.currentItem.iIndex] = 0;
        }
        if (typeof this.menus[this.currentItem.aIndex][this.currentItem.iIndex].sub !== 'undefined') {
            this.iCounter[this.currentItem.aIndex][this.currentItem.iIndex]++;
        }
        if (this.currentItem.flowQtt.length) {
            // update submenu quantity
            for (var i = 0; i < this.currentItem.flowQtt[menuid].length; i++) {
                this.subMenu[menuid][i].quantity += this.currentItem.flowQtt[menuid][i];
            }
        } else {
            this.iCounter[this.currentItem.aIndex][this.currentItem.iIndex] = 1;
        }

        this.requiredSelectCount = 0;

        this.hideDetailPopup(true);
        this.detailPopup(menuid);
    }

    // scroll menu layout item
    scrollToPage = (page = null) => {
        let element = document.querySelector('#layout' + page);
        if (element) {
            this.layouts._scrollContent.nativeElement.scrollTo(0, element['offsetTop']);
        }
    }

    isCheckedSubMenu() {
        var sampleElement = document.getElementsByClassName('img-selected');
        if (sampleElement != null && sampleElement.length > 0) {
            this.currentItem.isSelect[this.soIndex] = true;
            return true;
        } else {
            return false;
        }
    }

    validateTenkaiMenu() {
        if (this.currentItem.id !== 0 && this.foodDetailState === 'food-detail-up') {
            if (typeof this.subMenu !== 'undefined' && typeof this.subMenu[this.currentItem.id] !== 'undefined' && this.subMenu[this.currentItem.id].length > 0) {
                let icount = null;
                if (typeof this.iCounter[this.currentItem.aIndex] !== 'undefined'
                    && typeof this.iCounter[this.currentItem.aIndex][this.currentItem.iIndex] !== 'undefined') {
                    icount = this.iCounter[this.currentItem.aIndex][this.currentItem.iIndex];
                }

                // if (hasSubQty && !icount) {
                if (!icount) {
                    let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: this._loc.t('数量が入力されていません。'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
                    modal.present();
                    return false;
                }
            }
        }
        return true;
    }

    setMenuLimitQuantity() {
        this.quantityOption = [];
        let menuLimitQuantity = 99;
        this.storage.get('menu.list').then((m) => {
            var menuData = m.result.find(m => (m.menu_id == this.currentItem.id));
            var orderData = this.orderList.find(o => (o.menu_id == this.currentItem.id));
            if (menuData.menu_limit_in_order > 0) {
                menuLimitQuantity = menuData.menu_limit_in_order;
            }
            if (orderData) {
                menuLimitQuantity = menuLimitQuantity - orderData.quantity;
            }
            for (let i = 1; i <= menuLimitQuantity; i++) {
                this.quantityOption.push({
                    count: i
                });
            }
        });
    }

    sendOrder() {
        let menuQuantityText = String(this.quantity);
        let menuQuantity = parseInt(menuQuantityText);

        // グループメニューの場合
        if (this.currentItem.flowQtt) {
            let sameOrder = false;
            // カートに同じ注文があるかチェック
            for (let i = 0; i < this.orderList.length; i++) {
                if (this.orderList[i].menu_id == this.currentItem.id) {
                    sameOrder = true;
                    for (let j = 0; j < this.orderList[i].sub.length; j++) {
                        // 同じサブメニュー
                        if (this.currentItem.flowQttItem[this.currentItem.id][j].id && this.orderList[i].sub[j].menu_id == this.currentItem.flowQttItem[this.currentItem.id][j].id) {
                            let currentQuantity = this.orderList[i].sub[j].quantity;
                            let ordersQuantity = this.currentItem.flowQtt[this.currentItem.id][j];
                            // トッピングは数量が一致する場合同じと判定
                            if ((this.currentItem.flowQttItem[this.currentItem.id][j].as_topping == "1") && ordersQuantity != currentQuantity) sameOrder = false;
                            // トッピング以外は選択した項目が一致する場合に同じと判定
                            if ((this.currentItem.flowQttItem[this.currentItem.id][j].as_topping != "1") && ordersQuantity > 0 && currentQuantity != ordersQuantity) sameOrder = false;
                        }
                    }
                    // カートに同じ注文がある場合、数量のみ変更
                    if (sameOrder) {
                        this.orderList[i].quantity = this.orderList[i].quantity + menuQuantity;
                        this.orderList[i].origin_quantity = this.orderList[i].origin_quantity + menuQuantity;
                        break;
                    }
                }
            }

            // カートに同じ注文がない
            if (!sameOrder) {
                //親メニュー追加
                this.orderList.push(
                    {
                        orderListNum: this.orderListNum++,
                        price: this.currentItem.price,
                        notax_price: this.menus[this.currentItem.aIndex][this.currentItem.iIndex].notax_price,
                        menu: {
                            menu_id: this.currentItem.id,
                        },
                        menu_id: this.currentItem.id,
                        title: this.menus[this.currentItem.aIndex][this.currentItem.iIndex].title,
                        origin_quantity: menuQuantity,
                        original_especial_price: this.currentItem.price,
                        quantity: menuQuantity,
                        remarks: "OkageGo",
                        sub: [],
                        menu_limit_in_order: this.currentItem.menu_limit_in_order,
                    }
                );
                //サブメニュー追加
                for (let i = 0; i < this.currentItem.flowQttItem[this.currentItem.id].length; i++) {
                    let subQuantity = this.currentItem.flowQtt[this.currentItem.id][i];
                    this.orderList[this.orderList.length-1].sub.push(
                        {
                            orderListSubNum: i,
                            price: this.currentItem.flowQttItem[this.currentItem.id][i].price,
                            notax_price: this.currentItem.flowQttItem[this.currentItem.id][i].notax_price,
                            menu: {
                                menu_id: this.currentItem.flowQttItem[this.currentItem.id][i].id,
                            },
                            menu_id: this.currentItem.flowQttItem[this.currentItem.id][i].id,
                            title: this.currentItem.flowQttItem[this.currentItem.id][i].title,
                            origin_quantity: this.currentItem.flowQtt[this.currentItem.id][i],
                            original_especial_price: this.currentItem.flowQttItem[this.currentItem.id][i].price,
                            parent_menu_id: this.currentItem.flowQttItem[this.currentItem.id][i].parent,
                            quantity: subQuantity,
                            as_topping: this.currentItem.flowQttItem[this.currentItem.id][i].as_topping,
                            remarks: "OkageGo",
                        }
                    );
                }
            }
        } else {　// 単品メニューの場合
            const findMenuIndex = this.orderList.findIndex((v) => v.menu_id === this.currentItem.id);
            // カートに同じ注文がない場合
            if (findMenuIndex < 0) {
                this.orderList.push(
                    {
                        orderListNum: this.orderListNum++,
                        price: this.currentItem.price,
                        notax_price: this.menus[this.currentItem.aIndex][this.currentItem.iIndex].notax_price,
                        menu: {
                            menu_id: this.currentItem.id,
                        },
                        menu_id: this.currentItem.id,
                        title: this.menus[this.currentItem.aIndex][this.currentItem.iIndex].title,
                        origin_quantity: menuQuantity,
                        original_especial_price: this.currentItem.price,
                        quantity: menuQuantity,
                        remarks: "OkageGo",
                        sub: [],
                        menu_limit_in_order: this.currentItem.menu_limit_in_order,
                    }
                );
            } else { // カートに同じ注文がある場合
                this.orderList[findMenuIndex].quantity = this.orderList[findMenuIndex].quantity + menuQuantity;
                this.orderList[findMenuIndex].origin_quantity = this.orderList[findMenuIndex].origin_quantity + menuQuantity;
            }
        }

        if (!this.subMenuTotal) {
            this.subMenuTotal = JSON.parse(JSON.stringify(this.subMenu));
        }
        if (this.iCounter.length == 0) {
            if (!this.iCounter[this.currentItem.aIndex]) {
                this.iCounter[this.currentItem.aIndex] = [];
            }
            if (!this.iCounter[this.currentItem.aIndex][this.currentItem.iIndex]) {
                this.iCounter[this.currentItem.aIndex][this.currentItem.iIndex] = 0;
            }
            if (typeof this.menus[this.currentItem.aIndex][this.currentItem.iIndex].sub !== 'undefined') {
                this.iCounter[this.currentItem.aIndex][this.currentItem.iIndex]++;
            }
            if (this.currentItem.flowQtt.length) {
                // update submenu quantity
                for (var i = 0; i < this.currentItem.flowQtt[this.currentItem.id].length; i++) {
                    this.subMenu[this.currentItem.id][i].quantity = this.currentItem.flowQtt[this.currentItem.id][i];
                }
            } else {
                this.iCounter[this.currentItem.aIndex][this.currentItem.iIndex] = 1;
            }
        }

        for (let i = 0; i < this.iCounter.length; i++) {
            if (this.iCounter[i]) {
                if (!this.iCounterTotal[i]) {
                    this.iCounterTotal[i] = [];
                }
                for (let j = 0; j < this.iCounter[i].length; j++) {
                    if (this.iCounter[i][j]) {
                        if (!this.iCounterTotal[i][j]) {
                            this.iCounterTotal[i][j] = this.iCounter[i][j] * this.quantity;
                        } else {
                            this.iCounterTotal[i][j] += this.iCounter[i][j] * this.quantity;
                        }
                    }
                }
            }
        }

        for (let i in this.subMenu) {
            if (!this.subMenuTotal[i]) {
                this.subMenuTotal[i] = [];
            }
            for (let j = 0; j < this.subMenu[i].length; j++) {
                if (!this.subMenuTotal[i][j]) {
                    this.subMenuTotal[i][j] = this.subMenu[i][j];
                    this.subMenuTotal[i][j].quantity *= this.quantity;
                } else {
                    this.subMenuTotal[i][j].quantity += this.subMenu[i][j].quantity * this.quantity;;
                }
            }
        }

        if (this.chargeId && localStorage.getItem("receiveMethod") === 'delivery') {
          for(let i = 0; i < this.orderList.length; i++) {
            if (this.orderList[i].menu_id === this.chargeId) {
              this.orderList.splice(i, 1);
            }
          }
          for (let a = 0; a < this.menus.length; a++) {
            for (let b = 0; b < this.menus[a].length; b++) {
              if (this.menus[a][b].id == this.chargeId) {
                this.orderList.push({
                  orderListNum: this.orderListNum++,
                  price: this.menus[a][b].price,
                  notax_price: this.menus[a][b].notax_price,
                  menu: {
                      menu_id: this.menus[a][b].id,
                  },
                  menu_id: this.menus[a][b].id,
                  title: this.menus[a][b].title,
                  origin_quantity: 1,
                  original_especial_price: this.menus[a][b].price,
                  quantity: 1,
                  remarks: "OkageGo",
                  sub: [],
                });
                break;
              }
            }
          }
        }
        //this.storage.set('foods.selected', this.iCounter).then((a) => {
        localStorage.setItem("orderList", JSON.stringify(this.orderList));
        this.storage.set('foods.selected', this.iCounterTotal).then((a) => {
            this.countTotal();
            this._okageStorage.setItem('foods.submenu', JSON.stringify(this.subMenuTotal));
            this.broadcaster.broadcast('foodCounterChanged', 1);
            this.broadcaster.broadcast('submenuChanged', 1);

            let r = this.validateTenkaiMenu();
            let total = 0;
            // for (var i = 0; i < 3; i++) {
            //     if (this.iCounterTotal[i]) {
            //         for (var j = 0; j < this.iCounterTotal[i].length; j++) {
            //             if (this.iCounterTotal[i][j]) {
            //                 total += this.iCounterTotal[i][j];
            //             }
            //         }
            //     }
            // }
            for (let i = 0; i < this.orderList.length; i++) {
              if (this.orderList[i].menu_id !== this.chargeId) {
                total += this.orderList[i].quantity;
              }
            }
            if (r) {
                let modal = this.modalCtrl.create(OrderModalPage, { total }, { showBackdrop: false, enableBackdropDismiss: false, enterAnimation: "modal-md-slide-in", leaveAnimation: "modal-md-slide-out" });
                modal.onDidDismiss(data => {
                    if (data === 1) {
                        if (this.foodDetailSubsState == "food-detail-up" || this.foodDetailSubsState == "food-detail-up-sequence") {
                            this.hideDetailPopup(true, true);
                        }
                        else if (this.foodDetailState == "food-detail-up") {
                            this.hideDetailPopup(false, true);
                        }
                        this.navCtrl.parent.select(Config.tab_menu_number.sendorderpage);
                    }
                    else if (data === 2) {
                        if (this.foodDetailSubsState == "food-detail-up" || this.foodDetailSubsState == "food-detail-up-sequence") {
                            this.hideDetailPopup(true, true);
                        }
                        else if (this.foodDetailState == "food-detail-up" || this.foodDetailSubsState == "food-detail-up-sequence") {
                            this.hideDetailPopup(false, true);
                        }
                    }
                });
                modal.present();
                // this.navCtrl.parent.select(Config.tab_menu_number.sendorderpage);
            }
        }); console.log("last this.orderList :"+this.orderList);
    }

    goCart() {
        this.navCtrl.parent.select(Config.tab_menu_number.sendorderpage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/menulayouts/menulayouts.ts